import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M19 10l-5-5v4.25L1 9.2426V10.75h13V15z'],
  height: 20,
  width: 20,
});
